export default __webpack_public_path__ + "static/media/TrophyActive.4d533c04.svg";